export const GET_FREE_TIMESLOT = 'GET_FREE_TIMESLOT';
export const GET_SINGLE_TIMESLOT = 'GET_SINGLE_TIMESLOT';
